import { useEffect, useState } from 'react';

/**
 * A hook that provides a synchronized tick for "time since" displays.
 * All components using this hook will update their time display simultaneously,
 * preventing the confusing situation where different events show different
 * relative times (e.g., event 1 shows "7 seconds ago" while event 2 shows "2 seconds ago").
 */
export const useTimeSinceTick = () => {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTick((prev) => prev + 1);
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);

  return tick;
};
